package redmcrosco.alex.farmatch.utils

object ItalianCfUtils {
    private val setPari = mapOf('0' to 0, '1' to 1, '2' to 2, '3' to 3, '4' to 4, '5' to 5, '6' to 6, '7' to 7, '8' to 8, '9' to 9, 'A' to 0, 'B' to 1, 'C' to 2, 'D' to 3, 'E' to 4, 'F' to 5, 'G' to 6, 'H' to 7, 'I' to 8, 'J' to 9, 'K' to 10, 'L' to 11, 'M' to 12, 'N' to 13, 'O' to 14, 'P' to 15, 'Q' to 16, 'R' to 17, 'S' to 18, 'T' to 19, 'U' to 20, 'V' to 21, 'W' to 22, 'X' to 23, 'Y' to 24, 'Z' to 25)
    private val setDispari = mapOf('0' to 1, '1' to 0, '2' to 5, '3' to 7, '4' to 9, '5' to 13, '6' to 15, '7' to 17, '8' to 19, '9' to 21, 'A' to 1, 'B' to 0, 'C' to 5, 'D' to 7, 'E' to 9, 'F' to 13, 'G' to 15, 'H' to 17, 'I' to 19, 'J' to 21, 'K' to 2, 'L' to 4, 'M' to 18, 'N' to 20, 'O' to 11, 'P' to 3, 'Q' to 6, 'R' to 8, 'S' to 12, 'T' to 14, 'U' to 16, 'V' to 10, 'W' to 22, 'X' to 25, 'Y' to 24, 'Z' to 23)
    private val setControllo = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    private val omocodiaMap = mapOf('L' to '0', 'M' to '1', 'N' to '2', 'P' to '3', 'Q' to '4', 'R' to '5', 'S' to '6', 'T' to '7', 'U' to '8', 'V' to '9')

    private fun decode(c: Char): Char = omocodiaMap[c] ?: c

    fun isCodiceFiscaleValido(cf: String): Boolean {
        val input = cf.uppercase().trim()
        if (input.length != 16) return false
        var somma = 0
        for (i in 0 until 15) {
            val char = input[i]
            somma += if ((i + 1) % 2 == 0) setPari[char] ?: 0 else setDispari[char] ?: 0
        }
        return input[15] == setControllo[somma % 26]
    }

    fun validaTutto(nome: String, cognome: String, sesso: String, data: String, cf: String): String? {
        val cfPuro = cf.uppercase().trim()
        if (cfPuro.length != 16) return "Il Codice Fiscale deve essere di 16 caratteri."
        if (!isCodiceFiscaleValido(cfPuro)) return "Il carattere di controllo finale del CF non è corretto."

        val parts = data.split("/")
        if (parts.size != 3) return "Inserisci la data di nascita nel formato GG/MM/AAAA."

        val giornoNascita = parts[0].toIntOrNull() ?: 0
        val meseNascita = parts[1].padStart(2, '0')
        val annoNascita = parts[2].takeLast(2)

        val giornoCFStr = cfPuro.substring(9, 11).map { decode(it) }.joinToString("")
        val giornoCF = giornoCFStr.toIntOrNull() ?: 0
        val meseCFChar = cfPuro[8]
        val annoCF = cfPuro.substring(6, 8).map { decode(it) }.joinToString("")

        val mesiMap = mapOf('A' to "01", 'B' to "02", 'C' to "03", 'D' to "04", 'E' to "05", 'H' to "06", 'L' to "07", 'M' to "08", 'P' to "09", 'R' to "10", 'S' to "11", 'T' to "12")

        // 1. SESSO VS GIORNO CF
        if (sesso == "M") {
            if (giornoCF != giornoNascita) return "Incoerenza Sesso: Per un UOMO nato il giorno $giornoNascita, il CF deve contenere '$giornoNascita', non '$giornoCFStr'."
        } else if (sesso == "F") {
            val giornoDonna = giornoNascita + 40
            if (giornoCF != giornoDonna) return "Incoerenza Sesso: Per una DONNA nata il giorno $giornoNascita, il CF deve contenere '$giornoDonna', non '$giornoCFStr'."
        }

        // 2. DATA (ANNO/MESE)
        if (annoCF != annoNascita) return "L'anno nel CF ($annoCF) non corrisponde all'anno di nascita ($annoNascita)."
        if (mesiMap[meseCFChar] != meseNascita) return "Il mese nel CF non corrisponde al mese di nascita."

        // 3. COGNOME (Prime 3 lettere)
        val cognomeUpper = cognome.trim().uppercase().filter { it.isLetter() }
        val consCognome = cognomeUpper.filter { it !in "AEIOU" }
        val vocCognome = cognomeUpper.filter { it in "AEIOU" }
        val codiceCognome = (consCognome + vocCognome + "XXX").take(3)
        if (cfPuro.substring(0, 3) != codiceCognome) return "Il cognome $cognome non corrisponde al codice CF (${cfPuro.substring(0, 3)}). Dovrebbe essere $codiceCognome."

        // 4. NOME (Lettere 4-6)
        val nomeUpper = nome.trim().uppercase().filter { it.isLetter() }
        val consNome = nomeUpper.filter { it !in "AEIOU" }
        val vocNome = nomeUpper.filter { it in "AEIOU" }
        val codiceNome = if (consNome.length >= 4) "" + consNome[0] + consNome[2] + consNome[3]
                         else (consNome + vocNome + "XXX").take(3)
        if (cfPuro.substring(3, 6) != codiceNome) return "Il nome $nome non corrisponde al codice CF (${cfPuro.substring(3, 6)}). Dovrebbe essere $codiceNome."

        return null
    }
}
